import http from "infra/http";
import { useMutation } from "react-query";

function useAtivarPagamentoOnlineTenant(tenantId: string) {
  return useMutation(`/v1/tenants/${tenantId}/ativar-pagamento-online`, () =>
    http.post(`/v1/tenants/${tenantId}/ativar-pagamento-online`)
  );
}

export default useAtivarPagamentoOnlineTenant;
